var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89844 6.87207H4.55705V24.9639H2.89844V6.87207Z",
    fill: "url(#paint0_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56143 25.7588H3.02662C2.75305 25.7588 2.53125 25.5371 2.53125 25.2634V24.5823C2.53125 24.3087 2.75305 24.0869 3.02662 24.0869H4.56143V25.7588Z",
    fill: "url(#paint1_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5799 14.5895H4.11311L2.91838 7.30547C2.85388 6.90566 2.94737 6.49681 3.17689 6.16313C3.87323 5.15087 4.69745 4.23309 5.62608 3.43316C6.44509 2.72765 7.72076 3.19272 7.89306 4.25982L9.5799 14.5895Z",
    fill: "url(#paint2_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57875 14.5895L7.89191 4.25985C7.84736 3.98409 7.72877 3.74892 7.56375 3.56338C7.18772 3.50503 6.78402 3.59902 6.45423 3.88307C5.5256 4.68301 4.70138 5.60078 4.00504 6.61305C3.77552 6.94672 3.68196 7.35557 3.74653 7.75538L4.86747 14.5895H9.57875Z",
    fill: "url(#paint3_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 6.87207H29.0961V24.9639H27.4375V6.87207Z",
    fill: "url(#paint4_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 9.58594V24.9638H29.0961V11.2445L27.4375 9.58594Z",
    fill: "url(#paint5_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 25.7588H28.9723C29.2459 25.7588 29.4677 25.5371 29.4677 25.2634V24.5823C29.4677 24.3087 29.2459 24.0869 28.9723 24.0869H27.4375V25.7588Z",
    fill: "url(#paint6_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4219 14.5895H27.8887L29.0834 7.30547C29.1479 6.90566 29.0544 6.49681 28.8249 6.16313C28.1285 5.15087 27.3043 4.23309 26.3757 3.43316C25.5567 2.72765 24.281 3.19272 24.1087 4.25982L22.4219 14.5895Z",
    fill: "url(#paint7_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8875 14.5898L29.0822 7.3058C29.1467 6.90599 29.0532 6.49714 28.8237 6.16346C28.5433 5.75593 28.2413 5.36459 27.9211 4.98925C27.6123 4.66844 27.2889 4.36161 26.9513 4.07085C26.1323 3.36535 24.8566 3.83041 24.6843 4.89752L23.1016 14.5898H27.8875Z",
    fill: "url(#paint8_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7031 14.59H27.8873L28.5298 10.6724L24.7031 6.8457V14.59Z",
    fill: "url(#paint9_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7341 7.46855H12.2656V3.73421C12.2656 1.67517 13.9407 0 15.9998 0C18.0589 0 19.7341 1.67517 19.7341 3.73421V7.46855ZM14.1401 5.59404H17.8595V3.73427C17.8595 2.70877 17.0253 1.87457 15.9998 1.87457C14.9743 1.87457 14.1401 2.70883 14.1401 3.73427V5.59404Z",
    fill: "url(#paint10_radial_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2762 31.0796C19.1535 32.3064 12.8483 32.3064 6.72568 31.0796C5.15429 30.7647 4.02344 29.3847 4.02344 27.7821V15.0742C4.02344 8.45919 9.38595 3.09668 16.001 3.09668C22.6159 3.09668 27.9785 8.45919 27.9785 15.0742V27.7821C27.9785 29.3847 26.8476 30.7647 25.2762 31.0796Z",
    fill: "url(#paint11_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4932 4.58984C10.8781 4.58984 5.51562 9.95235 5.51562 16.5674V29.2753C5.51562 29.8153 5.64444 30.3296 5.87472 30.7868C6.13868 30.9195 6.42348 31.0193 6.72466 31.0796C12.8473 32.3065 19.1525 32.3065 25.2751 31.0796C26.8465 30.7648 27.9774 29.3848 27.9774 27.7822V15.0742C27.9774 12.1469 26.9266 9.46526 25.1825 7.3847C23.102 5.64057 20.4205 4.58984 17.4932 4.58984V4.58984Z",
    fill: "url(#paint12_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9883 4.69922C23.2533 6.67914 23.9868 9.03158 23.9868 11.5554V25.0845C23.9868 26.7907 22.7828 28.2598 21.1099 28.595C15.5638 29.7064 9.87714 29.8715 4.28906 29.0917C4.71203 30.0917 5.60715 30.8562 6.72608 31.0805C12.8487 32.3073 19.1539 32.3073 25.2765 31.0805C26.8479 30.7656 27.9788 29.3856 27.9788 27.783V15.075C27.9789 10.641 25.5693 6.76993 21.9883 4.69922V4.69922Z",
    fill: "url(#paint13_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2785 31.0796C26.8499 30.7648 27.9807 29.3848 27.9807 27.7822V21.181L25.7604 18.9607C25.2763 18.44 24.6048 18.0993 23.8616 18.038C18.6217 17.6058 13.3848 17.6058 8.14479 18.038C6.86454 18.1436 5.79612 19.0769 5.53435 20.3345C5.07192 22.556 5.07185 24.7313 5.53435 26.9531C5.65946 27.5542 5.96923 28.0809 6.39797 28.4789L9.46294 31.5439C14.7168 32.2788 20.0639 32.1245 25.2785 31.0796Z",
    fill: "url(#paint14_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02344 27.0117V27.7829C4.02344 29.3856 5.15429 30.7655 6.72568 31.0804C12.8483 32.3072 19.1535 32.3072 25.2761 31.0804C26.8475 30.7655 27.9784 29.3855 27.9784 27.7829V27.0117H4.02344Z",
    fill: "url(#paint15_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13337 22.7827C6.08035 22.6802 5.97463 22.6094 5.85127 22.6094C5.67521 22.6094 5.53246 22.7521 5.53246 22.9282V22.9621C5.06683 23.0998 4.72656 23.5302 4.72656 24.0402V25.8862C4.72656 26.2314 4.88267 26.5401 5.12769 26.7465L9.99715 31.6159C11.3089 31.784 12.6259 31.8967 13.9448 31.9542V31.009C13.9448 30.6986 13.8188 30.4174 13.6148 30.2142L6.13337 22.7827Z",
    fill: "url(#paint16_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8617 29.2497C18.6217 29.6819 13.3849 29.6819 8.14483 29.2497C6.86458 29.1441 5.79616 28.2107 5.53432 26.9531C5.07183 24.7313 5.07195 22.556 5.53432 20.3345C5.7961 19.0769 6.86458 18.1435 8.14477 18.038C13.3848 17.6058 18.6216 17.6058 23.8616 18.038C25.1419 18.1436 26.2103 19.0769 26.4721 20.3345C26.9345 22.556 26.9345 24.7313 26.4721 26.9531C26.2104 28.2107 25.142 29.1441 23.8617 29.2497V29.2497Z",
    fill: "url(#paint17_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4734 20.3351C26.2116 19.0775 25.1431 18.1442 23.8629 18.0386C23.5578 18.0134 23.2526 17.99 22.9475 17.9678C23.3726 20.1261 23.3618 22.2433 22.912 24.4043C22.6502 25.662 21.5817 26.5954 20.3014 26.7009C15.3666 27.1079 10.4345 27.1313 5.5 26.7717C5.51192 26.8323 5.5229 26.8929 5.53551 26.9536C5.79729 28.2112 6.86577 29.1446 8.14602 29.2502C13.3861 29.6823 18.6229 29.6823 23.8629 29.2502C25.1432 29.1446 26.2117 28.2112 26.4734 26.9536C26.9359 24.7318 26.9358 22.5565 26.4734 20.3351V20.3351Z",
    fill: "url(#paint18_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8561 29.2494C25.1363 29.1438 26.2048 28.2104 26.4666 26.9528C26.9291 24.731 26.929 22.5557 26.4666 20.3343C26.4207 20.1136 26.3494 19.9032 26.257 19.7052C25.8867 19.4876 25.4654 19.3493 25.0179 19.3124C19.7779 18.8802 14.5411 18.8802 9.30104 19.3124C8.02079 19.418 6.95237 20.3514 6.6906 21.609C6.22817 23.8304 6.2281 26.0057 6.6906 28.2275C6.73653 28.4482 6.80781 28.6586 6.90023 28.8566C7.27049 29.0742 7.69188 29.2125 8.13932 29.2494C13.3792 29.6817 18.6161 29.6816 23.8561 29.2494Z",
    fill: "url(#paint19_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23763 22.3714C5.20714 22.7481 5.19095 23.1242 5.1875 23.5003C8.45909 23.3262 12.1926 23.2341 16.0014 23.2341C19.8101 23.2341 23.5436 23.3262 26.8152 23.5003C26.8118 23.1242 26.7956 22.7481 26.7651 22.3714C23.5001 22.2 19.7871 22.1094 16.0014 22.1094C12.2157 22.1094 8.50264 22.2 5.23763 22.3714V22.3714Z",
    fill: "url(#paint20_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4454 23.2721C26.4399 23.2721 26.4344 23.272 26.4289 23.2717C26.0609 23.2518 25.687 23.233 25.3077 23.2152C25.1422 23.2075 25.0143 23.067 25.0221 22.9016C25.0298 22.7362 25.1711 22.6075 25.3357 22.616C25.7164 22.6339 26.0918 22.6527 26.4612 22.6727C26.6266 22.6816 26.7535 22.823 26.7445 22.9884C26.7359 23.1483 26.6035 23.2721 26.4454 23.2721ZM6.95598 23.2026C6.79648 23.2026 6.66383 23.0771 6.65656 22.9162C6.64915 22.7507 6.77728 22.6106 6.94274 22.6031C7.31331 22.5865 7.68878 22.5708 8.06857 22.5563C8.2334 22.5493 8.37339 22.679 8.37972 22.8445C8.38606 23.01 8.25699 23.1494 8.09147 23.1557C7.71306 23.1702 7.33891 23.1857 6.96965 23.2023C6.96507 23.2025 6.96049 23.2026 6.95598 23.2026ZM23.8235 23.1524C23.8197 23.1524 23.8159 23.1523 23.8121 23.1521C23.4419 23.1381 23.0676 23.1251 22.6897 23.1132C22.5242 23.1079 22.3943 22.9694 22.3995 22.8039C22.4048 22.6383 22.5426 22.5117 22.7088 22.5136C23.0878 22.5256 23.4633 22.5387 23.8347 22.5527C24.0002 22.5589 24.1293 22.6982 24.123 22.8637C24.117 23.0254 23.984 23.1524 23.8235 23.1524V23.1524ZM9.57866 23.1046C9.41721 23.1046 9.28394 22.9762 9.27905 22.8137C9.27403 22.6482 9.40416 22.5099 9.56975 22.5049C9.94195 22.4936 10.3175 22.4833 10.6959 22.4741C10.8609 22.4683 10.999 22.6009 11.0031 22.7666C11.0071 22.9321 10.8762 23.0697 10.7106 23.0738C10.3334 23.083 9.95902 23.0931 9.58794 23.1044C9.58487 23.1045 9.58173 23.1046 9.57866 23.1046V23.1046ZM21.2008 23.0716C21.1984 23.0716 21.1959 23.0716 21.1935 23.0716C20.8219 23.0626 20.4477 23.0546 20.0711 23.0475C19.9054 23.0445 19.7737 22.9077 19.7768 22.742C19.7799 22.5764 19.9173 22.4435 20.0823 22.4478C20.46 22.4549 20.8353 22.4629 21.2079 22.4718C21.3735 22.4758 21.5045 22.6133 21.5005 22.7788C21.4966 22.942 21.3631 23.0716 21.2008 23.0716ZM12.203 23.0426C12.0398 23.0426 11.9061 22.9117 11.9032 22.7479C11.9004 22.5822 12.0323 22.4457 12.198 22.4428C12.5715 22.4363 12.9472 22.4308 13.3246 22.4262H13.3283C13.4923 22.4262 13.6262 22.5581 13.6281 22.7226C13.6301 22.8882 13.4975 23.0241 13.3318 23.0261C12.9554 23.0306 12.5808 23.0361 12.2082 23.0424C12.2065 23.0426 12.2048 23.0426 12.203 23.0426ZM18.5775 23.0249C18.5763 23.0249 18.5752 23.0249 18.5739 23.0249C18.2012 23.0206 17.8267 23.0172 17.451 23.0147C17.2854 23.0136 17.152 22.8784 17.1531 22.7128C17.1541 22.5472 17.2878 22.4122 17.4549 22.4149C17.8316 22.4174 18.207 22.4208 18.5808 22.4251C18.7465 22.427 18.8792 22.5628 18.8772 22.7285C18.8754 22.8929 18.7415 23.0249 18.5775 23.0249V23.0249ZM14.8282 23.0131C14.6633 23.0131 14.5292 22.8798 14.5284 22.7148C14.5275 22.5491 14.6611 22.4141 14.8267 22.4132C15.2012 22.4112 15.5768 22.4102 15.9532 22.4102C16.1189 22.4102 16.2532 22.5444 16.2532 22.71C16.2533 22.8757 16.119 23.01 15.9534 23.01C15.578 23.0101 15.2033 23.0111 14.8299 23.0131C14.8294 23.0131 14.8288 23.0131 14.8282 23.0131V23.0131Z",
    fill: "url(#paint21_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13695 22.7827C6.08393 22.6802 5.9782 22.6094 5.85484 22.6094C5.67878 22.6094 5.53604 22.7521 5.53604 22.9282V22.9621C5.41237 22.9987 5.29792 23.0564 5.19596 23.1303C5.15436 24.4009 5.26611 25.6693 5.53334 26.9531C5.55204 27.043 5.57532 27.131 5.60204 27.2174L7.50993 29.1253C7.71317 29.189 7.92525 29.2317 8.14379 29.2497C9.73795 29.3812 11.3319 29.4721 12.9257 29.5236L6.13695 22.7827Z",
    fill: "url(#paint22_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64606 23.2459C6.44283 23.042 6.16167 22.916 5.85127 22.916C5.23041 22.916 4.72656 23.4199 4.72656 24.0407V25.8867C4.72656 26.5076 5.23047 27.0114 5.85127 27.0114C6.47213 27.0114 6.97598 26.5076 6.97598 25.8867V24.0407C6.97598 23.7303 6.84999 23.4491 6.64606 23.2459V23.2459ZM5.85127 24.6871C5.51985 24.6871 5.25143 24.4186 5.25143 24.0872C5.25143 23.7558 5.51985 23.4874 5.85127 23.4874C6.18269 23.4874 6.45111 23.7558 6.45111 24.0872C6.45111 24.4186 6.18269 24.6871 5.85127 24.6871Z",
    fill: "url(#paint23_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85441 23.0371C5.27446 23.0371 4.80469 23.5069 4.80469 24.0868C4.80469 24.6668 5.27446 25.1366 5.85441 25.1366C6.43437 25.1366 6.90414 24.6668 6.90414 24.0868C6.90414 23.5068 6.43437 23.0371 5.85441 23.0371ZM5.85441 24.6867C5.52299 24.6867 5.25457 24.4182 5.25457 24.0868C5.25457 23.7554 5.52299 23.487 5.85441 23.487C6.18583 23.487 6.45426 23.7554 6.45426 24.0868C6.45426 24.4182 6.18583 24.6867 5.85441 24.6867Z",
    fill: "url(#paint24_radial_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85006 23.8455C5.674 23.8455 5.53125 23.7028 5.53125 23.5267V22.9282C5.53125 22.7521 5.674 22.6094 5.85006 22.6094C6.02612 22.6094 6.16887 22.7521 6.16887 22.9282V23.5267C6.16881 23.7028 6.02612 23.8455 5.85006 23.8455Z",
    fill: "url(#paint25_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8659 15.8994H10.128C9.50504 15.8994 9 15.3944 9 14.7714V11.5537C9 10.9308 9.50497 10.4258 10.128 10.4258H21.8659C22.4889 10.4258 22.9939 10.9308 22.9939 11.5537V14.7714C22.9939 15.3944 22.4889 15.8994 21.8659 15.8994V15.8994Z",
    fill: "url(#paint26_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6035 15.4236H10.3868C9.83668 15.4236 9.39062 14.9776 9.39062 14.4274V11.8966C9.39062 11.3464 9.83662 10.9004 10.3868 10.9004H21.6035C22.1537 10.9004 22.5997 11.3464 22.5997 11.8966V14.4274C22.5997 14.9776 22.1537 15.4236 21.6035 15.4236Z",
    fill: "url(#paint27_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9952 12.5437C18.2501 12.5437 20.4777 12.5763 22.5997 12.6387V11.8966C22.5997 11.76 22.5721 11.6298 22.5224 11.5112C20.4224 11.4506 18.2218 11.4189 15.9952 11.4189C13.7686 11.4189 11.5679 11.4505 9.46799 11.5112C9.41823 11.6298 9.39062 11.7599 9.39062 11.8966V12.6387C11.5126 12.5763 13.7402 12.5437 15.9952 12.5437Z",
    fill: "url(#paint28_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.084 11.6719C14.0828 11.6719 14.0815 11.6719 14.0803 11.6719C13.7028 11.6733 13.3271 11.6758 12.9535 11.6792C12.7878 11.6807 12.6548 11.8162 12.6563 11.9818C12.6578 12.1457 12.7903 12.2777 12.9536 12.279H12.9589C13.3315 12.2757 13.7062 12.2732 14.0826 12.2718C14.2482 12.2711 14.3819 12.1363 14.3813 11.9707C14.3808 11.8062 14.2479 11.6733 14.084 11.6719V11.6719Z",
    fill: "url(#paint29_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4509 11.6984C11.0725 11.7045 10.6968 11.7118 10.3245 11.72C10.1589 11.7236 10.0277 11.8609 10.0313 12.0264C10.0349 12.189 10.1671 12.3184 10.3285 12.3197C10.3316 12.3197 10.3348 12.3197 10.3378 12.3196C10.709 12.3114 11.0834 12.3043 11.4607 12.2981C11.6263 12.2954 11.7584 12.159 11.7557 11.9934C11.7529 11.8276 11.6159 11.6938 11.4509 11.6984Z",
    fill: "url(#paint30_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7086 11.678C16.3322 11.675 15.9566 11.673 15.5821 11.6719C15.4164 11.6714 15.2818 11.8053 15.2813 11.971C15.2808 12.136 15.4138 12.2704 15.5787 12.2717H15.5803C15.9538 12.2728 16.3284 12.2748 16.7038 12.2778C16.8695 12.2792 17.0048 12.1459 17.0061 11.9803C17.0074 11.8147 16.8743 11.6794 16.7086 11.678V11.678Z",
    fill: "url(#paint31_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3364 11.7139C18.9626 11.7065 18.5873 11.7 18.2106 11.6944C18.0435 11.6903 17.9087 11.8243 17.9063 11.9899C17.9038 12.1555 18.0361 12.2918 18.2018 12.2942C18.5774 12.2998 18.9518 12.3062 19.3246 12.3136H19.3282C19.4922 12.3149 19.6271 12.184 19.6304 12.0196C19.6335 11.854 19.502 11.7171 19.3364 11.7139V11.7139Z",
    fill: "url(#paint32_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9646 11.7824C21.5921 11.7704 21.2168 11.7594 20.8392 11.7492C20.6743 11.7436 20.5358 11.8753 20.5314 12.0409C20.5269 12.2065 20.6575 12.3443 20.8231 12.3488C21.1997 12.359 21.5738 12.37 21.9453 12.382C21.9478 12.3821 21.9502 12.3821 21.9527 12.3821C22.115 12.3834 22.2495 12.2549 22.2547 12.0919C22.26 11.9263 22.1302 11.7877 21.9646 11.7824V11.7824Z",
    fill: "url(#paint33_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2349 11.8608C10.1819 11.7583 10.0762 11.6875 9.95283 11.6875C9.77677 11.6875 9.63402 11.8302 9.63402 12.0063V12.0403C9.16839 12.1779 8.82812 12.6083 8.82812 13.1183V14.9644C8.82812 15.3096 8.98424 15.6182 9.22925 15.8246L14.0987 20.694C15.4105 20.8621 16.7275 20.9748 18.0463 21.0323V20.0872C18.0463 19.7768 17.9203 19.4955 17.7164 19.2924L10.2349 11.8608Z",
    fill: "url(#paint34_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7476 12.3231C10.5444 12.1192 10.2632 11.9932 9.95283 11.9932C9.33197 11.9932 8.82812 12.497 8.82812 13.1179V14.9639C8.82812 15.5848 9.33197 16.0886 9.95283 16.0886C10.5737 16.0886 11.0775 15.5848 11.0775 14.9639V13.1179C11.0775 12.8074 10.9515 12.5262 10.7476 12.3231V12.3231ZM9.95283 13.7642C9.62141 13.7642 9.35299 13.4958 9.35299 13.1644C9.35299 12.8329 9.62141 12.5645 9.95283 12.5645C10.2842 12.5645 10.5527 12.8329 10.5527 13.1644C10.5527 13.4957 10.2842 13.7642 9.95283 13.7642Z",
    fill: "url(#paint35_linear_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95597 12.1143C9.37602 12.1143 8.90625 12.584 8.90625 13.164C8.90625 13.7439 9.37602 14.2137 9.95597 14.2137C10.5359 14.2137 11.0057 13.7439 11.0057 13.164C11.0057 12.584 10.5359 12.1143 9.95597 12.1143ZM9.95597 13.7638C9.62455 13.7638 9.35613 13.4954 9.35613 13.164C9.35613 12.8326 9.62455 12.5641 9.95597 12.5641C10.2874 12.5641 10.5558 12.8326 10.5558 13.164C10.5558 13.4953 10.2873 13.7638 9.95597 13.7638Z",
    fill: "url(#paint36_radial_152_592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95162 12.9227C9.77556 12.9227 9.63281 12.7799 9.63281 12.6039V12.0053C9.63281 11.8293 9.77556 11.6865 9.95162 11.6865C10.1277 11.6865 10.2704 11.8293 10.2704 12.0053V12.6039C10.2704 12.7799 10.1276 12.9227 9.95162 12.9227Z",
    fill: "url(#paint37_linear_152_592)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_592",
    x1: 2.51569,
    y1: 16.0957,
    x2: 5.32743,
    y2: 15.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_592",
    x1: 3.27465,
    y1: 24.3345,
    x2: 3.987,
    y2: 25.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_592",
    x1: 3.71869,
    y1: 6.63912,
    x2: 6.2305,
    y2: 9.52583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_592",
    x1: 5.82916,
    y1: 8.94152,
    x2: 1.8552,
    y2: 7.55441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FF813A",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7194,
    stopColor: "#FF9A2B",
    stopOpacity: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_592",
    x1: 29.4788,
    y1: 16.0957,
    x2: 26.6671,
    y2: 15.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_592",
    x1: 28.3678,
    y1: 17.915,
    x2: 23.6816,
    y2: 14.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "#D9874F",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_592",
    x1: 28.7243,
    y1: 24.3345,
    x2: 28.0119,
    y2: 25.4218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_592",
    x1: 28.2831,
    y1: 6.63912,
    x2: 25.7713,
    y2: 9.52583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_592",
    x1: 24.9139,
    y1: 9.229,
    x2: 19.8152,
    y2: 4.69271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#FF813A",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7194,
    stopColor: "#FF9A2B",
    stopOpacity: 0.719
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_592",
    x1: 29.4487,
    y1: 14.0397,
    x2: 22.7005,
    y2: 9.31597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664,
    stopColor: "#F32817",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4333,
    stopColor: "#D82723",
    stopOpacity: 0.433
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7567,
    stopColor: "#C7272A",
    stopOpacity: 0.757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_152_592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9998 3.73427) scale(3.2992 3.2992)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2925,
    stopColor: "#FFA727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5496,
    stopColor: "#FFB22D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7925,
    stopColor: "#FFC438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_592",
    x1: 6.77701,
    y1: 10.0284,
    x2: 28.2213,
    y2: 32.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_592",
    x1: 20.9729,
    y1: 23.6154,
    x2: 1.7779,
    y2: 7.64459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_592",
    x1: 15.8692,
    y1: 19.8042,
    x2: 39.1494,
    y2: 14.0685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_592",
    x1: 20.6304,
    y1: 32.8522,
    x2: 15.1819,
    y2: 20.6054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_592",
    x1: 16.001,
    y1: 29.6208,
    x2: 16.001,
    y2: 32.1746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_592",
    x1: 9.21742,
    y1: 28.2978,
    x2: 6.5931,
    y2: 24.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_152_592",
    x1: 12.9817,
    y1: 18.7722,
    x2: 20.3297,
    y2: 30.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_152_592",
    x1: 12.2637,
    y1: 23.4642,
    x2: 40.0814,
    y2: 24.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "#D9874F",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_152_592",
    x1: 17.0696,
    y1: 24.9738,
    x2: 10.6213,
    y2: 15.8762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#FDE82B",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_152_592",
    x1: 15.9886,
    y1: 23.7819,
    x2: 16.0654,
    y2: 21.6059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_152_592",
    x1: 16.7006,
    y1: 22.5475,
    x2: 16.7006,
    y2: 23.0224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_152_592",
    x1: 9.82937,
    y1: 28.258,
    x2: 1.90647,
    y2: 22.1346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "#D9874F",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_152_592",
    x1: 5.19477,
    y1: 24.5418,
    x2: 7.99407,
    y2: 26.3413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_152_592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.85441 24.0868) scale(0.962322 0.962318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#C5272B",
    stopOpacity: 0.736
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    stopColor: "#D12726",
    stopOpacity: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    stopColor: "#E6281D",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_152_592",
    x1: 5.53125,
    y1: 23.2275,
    x2: 6.16881,
    y2: 23.2275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_152_592",
    x1: 17.1251,
    y1: 16.1286,
    x2: 12.4763,
    y2: 3.90676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_152_592",
    x1: 15.8763,
    y1: 11.6764,
    x2: 16.1763,
    y2: 15.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_152_592",
    x1: 15.9952,
    y1: 12.3747,
    x2: 15.9952,
    y2: 10.9501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_152_592",
    x1: 13.5229,
    y1: 11.7627,
    x2: 13.5202,
    y2: 12.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_152_592",
    x1: 10.8976,
    y1: 11.7919,
    x2: 10.8948,
    y2: 12.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_152_592",
    x1: 16.1477,
    y1: 11.7662,
    x2: 16.1451,
    y2: 12.0985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_152_592",
    x1: 18.7723,
    y1: 11.7924,
    x2: 18.7696,
    y2: 12.1286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_152_592",
    x1: 21.3972,
    y1: 11.8488,
    x2: 21.3944,
    y2: 12.1925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_152_592",
    x1: 13.7871,
    y1: 17.471,
    x2: 6.71394,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_152_592",
    x1: 9.29633,
    y1: 13.619,
    x2: 12.0956,
    y2: 15.4185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_152_592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.95597 13.164) scale(0.962318 0.962326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#C5272B",
    stopOpacity: 0.736
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5348,
    stopColor: "#D12726",
    stopOpacity: 0.465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8073,
    stopColor: "#E6281D",
    stopOpacity: 0.193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_152_592",
    x1: 9.63281,
    y1: 12.3046,
    x2: 10.2704,
    y2: 12.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT5);
export default __webpack_public_path__ + "static/media/t5.6f3fef09a068fab29098804fabf1fbd4.svg";
export { ForwardRef as ReactComponent };